export const BRAND_NAME = 'CmPrime';
// Note: It is the main site url. Ex - quickexch.com, pay.quickexch,com, etc.
export const BRAND_DOMAIN = 'cmprime.com';
// Note: It is the main site url. Ex - quickexch.com, pay.quickexch,com, etc.
export const BRAND_DOMAIN_SKIN_URL = 'cmprime.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const OPERATORID = 'HypexDemo';
export const BACKEND_DOMAIN = 'cue88.com';
